import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HeaderStyle.css";
import logo from "../../assets/Dr-Brand-100x100.png";
import { Collapse } from "bootstrap";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t, i18n } = useTranslation();
  const collapseRef = useRef(null);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      document.documentElement.setAttribute(
        "dir",
        savedLanguage === "ar" ? "rtl" : "ltr"
      );
    } else {
      document.documentElement.setAttribute(
        "dir",
        i18n.language === "ar" ? "rtl" : "ltr"
      );
    }
  }, [i18n]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.documentElement.setAttribute(
      "dir",
      newLang === "ar" ? "rtl" : "ltr"
    );
    localStorage.setItem("language", newLang);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }

    if (collapseRef.current) {
      const bsCollapse = new Collapse(collapseRef.current, { toggle: false });
      bsCollapse.hide();
    }
  };

  const closeNavbar = () => {
    if (collapseRef.current) {
      const bsCollapse = new Collapse(collapseRef.current, { toggle: false });
      bsCollapse.hide();
    }
  };

  return (
    <header>
      <nav
        key={i18n.language}
        className={`navbar navbar-expand-lg fixed-top custom-navbar ${
          isScrolled
            ? "custom-navbar-scrolled"
            : "custom-navbar-transparent navbar-dark"
        }`}
      >
        <div className="container navbar-container">
          <button
            className="btn btn-outline-light language-btn d-lg-none"
            onClick={toggleLanguage}
            aria-label="Toggle language"
          >
            {i18n.language === "ar" ? "EN" : "AR"}
          </button>

          <a
            className="navbar-brand"
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("home");
            }}
          >
            <img src={logo} alt="Logo" className="navbar-logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse navbar-collapse-custom"
            id="navbarNav"
            ref={collapseRef}
          >
            <button
              className="navbar-close-btn"
              type="button"
              onClick={closeNavbar}
              aria-label="Close navigation"
            >
              ×
            </button>

            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#home"
                  title="Learn more Home"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("home");
                  }}
                >
                  {t("header.home")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#about"
                  title="Learn more about us"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("about");
                  }}
                >
                  {t("header.about")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#projects"
                  title="Learn more Vision and Goals"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("Vision&Goals");
                  }}
                >
                  {t("header.Vision&Goals")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#services"
                  title="Learn more services"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("services");
                  }}
                >
                  {t("header.services")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#Testimonials"
                  title="Learn more Testimonials"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("Testimonials");
                  }}
                >
                  {t("header.Testimonials")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#contact"
                  title="Learn more Contact"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("BookConsultation");
                  }}
                >
                  {t("header.contact")}
                </a>
              </li>
              {/* Language Button (Desktop Only) */}
              <li className="nav-item d-none d-lg-block">
                <button
                  className="btn btn-outline-light language-btn"
                  onClick={toggleLanguage}
                  aria-label="Toggle language"
                >
                  {i18n.language === "ar" ? "EN" : "AR"}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
